export default "__VITE_ASSET__BCkl9jQS__"